import * as classnames from "classnames";
import { someTime } from "./utils/misc";

declare const jQuery: any;
const $ = jQuery;

interface TooltipSettings {
    html: string;
    target: any; // JQuery|HTMLElement|string (input to $ for exactly 1 HTML element)
    className?: string|string[];
    x?: "center"|"left"|"right"; // default center
}

interface Position {
    left: number;
    top: number;
}

// returns JQuery
function createTooltip(settings: TooltipSettings) {
    const $target = $(settings.target);
    if ($target.length === 0) {
        console.error(`No tooltip target`);
        return;
    }
    settings.x = settings.x || "center";
    const globalWrapper: HTMLElement = document.getElementById("global-wrapper") || document.body;
    const $tooltip = $(`<div class="tooltip tooltip-${settings.x}">`).appendTo(globalWrapper);
    $(`<div>`).html(settings.html || "").appendTo($tooltip);
    $(`<div class="tooltip-close">`).prependTo($tooltip).on("click", function (event) {
        $tooltip.trigger("close");
        return false;
    });
    if (settings.className) {
        $tooltip.addClass(classnames(settings.className));
    }
    let isOpen = false;
    let isBusy = false;
    const closeAllTooltips = () => {
        $(".tooltip").trigger("close");
    };
    const open = async () => {
        if (isOpen || isBusy) return;
        closeAllTooltips();
        isBusy = isOpen = true;
        $tooltip.addClass("transitioning");
        await someTime(30);
        setPosition(settings, $target, $tooltip, globalWrapper);
        $tooltip.addClass("open").removeClass("transitioning");
        isBusy = false;
    };
    const close = async () => {
        if (!isOpen || isBusy) return;
        isBusy = false;
        isOpen = false;
        $tooltip.removeClass("open transitioning");
    };
    $(document.body).on("click", function () {
        $tooltip.trigger("close")
    });
    $tooltip.on("open", function (event) {
        event.stopPropagation();
        event.preventDefault();
        open();
    }).on("close", function (event) {
        event.stopPropagation();
        event.preventDefault();
        close();
    }).on("click", function (event) {
        event.stopPropagation();
    });
    return $tooltip;
}

function setPosition(settings: TooltipSettings, $target, $tooltip, globalWrapper: HTMLElement): void {
    const target: HTMLElement = $target[0];
    const position: Position = calcPosition(settings, target, globalWrapper, $tooltip);
    const tooltipWidth: number = $tooltip.outerWidth();
    const tooltipHeight: number = $tooltip.outerHeight();
    $tooltip.css(position);
    const tooltipRect: DOMRect = $tooltip[0].getBoundingClientRect();
    const tooltipRight: number = tooltipWidth + tooltipRect.x; // Don't use tooltipRect.right
    const tooltipBottom: number = tooltipHeight + tooltipRect.y; // Don't use tooltipRect.bottom
    if (tooltipRect.x < 0) {
        $tooltip.css({ left: "-=" + tooltipRect.x });
    } else if (tooltipRight > window.outerWidth) {
        $tooltip.css({ left: "-=" + (tooltipRight - window.outerWidth) });
    }
    if (tooltipRect.y < 0) {
        $tooltip.css({ top: "-=" + tooltipRect.y });
    } else if (tooltipBottom > window.outerHeight) {
        $tooltip.css({ top: "-=" + (tooltipBottom - window.outerHeight) });
    }
}

function calcPosition(settings: TooltipSettings, target: HTMLElement, globalWrapper: HTMLElement, $tooltip): Position {
    const targetRect: DOMRect = target.getBoundingClientRect();
    const globalRect: DOMRect = globalWrapper.getBoundingClientRect();
    let left: number = 0;
    switch (settings.x) {
        case "right":
            left = targetRect.right - (globalRect.x - globalWrapper.scrollLeft);
            break;
        case "left":
            left = (targetRect.left - (globalRect.x - globalWrapper.scrollLeft)) - $tooltip.outerWidth();
            break;
        case "center":
        default:
            left = ((targetRect.left + targetRect.width / 2) - (globalRect.x - globalWrapper.scrollLeft)) - $tooltip.outerWidth() / 2;
            break;
    }
    const top: number = (targetRect.y - (globalRect.y - globalWrapper.scrollTop)) - $tooltip.outerHeight();
    return { left, top };
}

if (!window["iw"]) {
    window["iw"] = {};
}

window["iw"].tooltip = {
    createTooltip
};
